<template>
  <vee-form v-slot="{ validate }" as="" :initial-errors="initialErrors">
    <form
      ref="formRef"
      class="standard-form"
      method="post"
      novalidate
      @submit.prevent="handleSubmit(validate)"
    >
      <text-input
        v-model="formData.first_name"
        input-id="first_name"
        label="First Name"
        :show-label="false"
        placeholder="First Name"
        rules="required|max:50"
        validate-as="First name"
        maxlength="50"
        data-hj-suppress
      />

      <text-input
        v-model="formData.last_name"
        input-id="last_name"
        label="Last Name"
        :show-label="false"
        placeholder="Last Name"
        rules="required|max:50"
        validate-as="Last name"
        maxlength="50"
        data-hj-suppress
      />

      <text-input
        v-model="formData.email"
        input-id="email"
        type="email"
        label="Email"
        :show-label="false"
        placeholder="Email Address"
        rules="required|email|max:100"
        :validate-aggressive="false"
        maxlength="100"
        data-hj-suppress
      />

      <text-input
        v-model="formData.access_code"
        input-id="access_code"
        type="tel"
        label="Verification Code"
        :show-label="false"
        placeholder="Verification Code"
        rules="required"
        validate-as="verification code"
        data-hj-suppress
      />

      <div class="form-actions">
        <div class="form-action">
          <csrf-input />
          <submit-button
            :submitting="processing"
            label="Verify Membership"
            submitting-label="Processing…"
            classes="-main"
            @submit-action="handleSubmit(validate)"
          />
        </div>
      </div>
    </form>
  </vee-form>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Form as VeeForm } from 'vee-validate'
import TextInput from '@/components/forms/text-input.vue'
import CsrfInput from '@/components/forms/csrf-input.vue'
import SubmitButton from '@/components/buttons/submit-button.vue'
import { errorBagToInitialErrors } from '@/utils/forms/validation-rules'

export default defineComponent({
  name: 'OrganizationJoinForm',
  components: {
    VeeForm,
    TextInput,
    CsrfInput,
    SubmitButton,
  },
  props: {
    errorBag: {
      type: Object,
      default: () => ({}),
    },
    initFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      processing: false,
      formData: {
        // defaults
        first_name: '',
        last_name: '',
        email: '',
        access_code: '',
        // initial / old form values
        ...this.initFormData,
      },
    }
  },

  computed: {
    // only return first error per field, backend returns array
    initialErrors(): Record<string, string> {
      return errorBagToInitialErrors(this.errorBag)
    },
  },

  // instance methods
  methods: {
    async handleSubmit(validate: Function) {
      if (this.processing) {
        return
      }

      this.processing = true

      try {
        const results = await validate()

        // invalid, stop
        if (!results.valid) {
          this.processing = false
          return
        }

        // traditional form submit
        if (this.$refs.formRef instanceof HTMLFormElement) {
          // wait until next tick to make sure v-model update
          await this.$nextTick()
          this.$refs.formRef.submit()
        }
      } catch (e) {
        this.processing = false
      }
    },
  },
})
</script>
